export const createIntersectionObserver = (
  targetElement: HTMLElement,
  customCallback: () => void
) => {
  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        customCallback();
        observer.disconnect();
      }
    });
  }, {
    root: null,
    rootMargin: '0px',
    threshold: 0
  } as IntersectionObserverInit );

  observer.observe(targetElement)
}
